// Foundations
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// Services
import { GoogleMapsService } from 'src/app/services/google-maps.service';
import { FranchiseLocation } from '../../../models/franchise.model';

@Component({
  selector: 'app-location-tile',
  templateUrl: './location-tile.component.html',
  styleUrls: ['./location-tile.component.scss'],
})
export class LocationTileComponent implements OnInit {
  ACTIVE_HEART_PATH = 'assets/svg/ico_heart_red.svg';
  INACTIVE_HEART_PATH = 'assets/svg/ico_heart_gray.svg';

  ACTIVE_CHECK_PATH = 'assets/svg/ico_check_solid.svg';
  INACTIVE_CHECK_PATH = 'assets/svg/ico_check_solid_gray.svg';

  @Input() locationData: FranchiseLocation;
  @Input() isPreferred = false;
  @Input() isEditMode = false; // set to true in Edit Preferred Location and Change Location screens
  @Input() isChangeMode = false; // (used with "isEditMode = true") set to true in Change Location screens
  @Input() isSelected = false;
  @Output() selectedChange = new EventEmitter();

  constructor(public googleMapsService: GoogleMapsService) {}

  ngOnInit(): void {}

  // Public Methods
  // ------------------------------------------------------------------------------------

  get getHeartPath(): string {
    if (this.isEditMode) {
      if (this.isSelected) {
        return this.ACTIVE_HEART_PATH;
      }
    } else {
      if (this.isPreferred) {
        return this.ACTIVE_HEART_PATH;
      }
    }
    return this.INACTIVE_HEART_PATH;
  }

  get getCheckPath(): string {
    return this.isSelected ? this.ACTIVE_CHECK_PATH : this.INACTIVE_CHECK_PATH;
  }

  get isNameActive(): boolean {
    if (this.isEditMode) {
      if (this.isSelected) {
        return true;
      }
    } else {
      if (this.isPreferred) {
        return true;
      }
    }
    return false;
  }

  handleSelect(): void {
    if (this.isEditMode) {
      this.selectedChange.emit();
    }
  }
}
